import { getStore, setStore } from "@/utils/localStorage";
import Cos from "cos-js-sdk-v5";
import { cosInfos, useryear } from "../api/common";
import CryptoJS from "crypto-js";

export default {
  namespaced: true,
  state: {
    isFullLoading: false,//加载动画
    studentMajor: JSON.parse(getStore("studentMajor")),//学生当前专业
    menuActive: getStore('menuActive'),//当前菜单
    teacherRole: getStore('teacherRole'),//老师角色
    fontClass: 'uni-small',//字体大小

    time: getStore('time') || '',  //上传图片时间戳

    // startYearList: getStore('startYearList') || [],  //学年列表

    // 腾讯云签名
    // cos: null,
    // cosDatas: {
    //   Bucket: 'tcr-4w06clvb-1303139375',
    //   Region: "ap-beijing",
    // },
    // cos: new Cos({
    //   AppId: '1303139375',
    //   SecretId: 'AKIDNYT8WdU4NPAespUt1sSlmX1EApDKAk35',
    //   SecretKey: 'lFTQ6Vdtsa2D6i37uQfdJiqhIcfRwA7n',
    // }),
    // cosDatas: {
    //   Bucket: 'tcr-4w06clvb-1303139375',
    //   Region: "ap-beijing",
    //   AppId: '1303139375',
    //   SecretId: 'AKIDNYT8WdU4NPAespUt1sSlmX1EApDKAk35',
    //   SecretKey: 'lFTQ6Vdtsa2D6i37uQfdJiqhIcfRwA7n',
    // },
    // 天翼云签名
    // s3Client: null,  //单个文件上传
    s3ClientKV: '0a6b7fb4cff6c74d',  //crypto-js 解密
    // s3ClientConfig: {
    //     accessKeyId: "",  //VMrUKyeelHFJkWid0njQ
    //     secretAccessKey: "",   //B0cRh3Ef1Ban0Q2gGuhhmQqAECbMd8fGLzoQ0Beb
    //     endpoint: "",  //shoss.xstore.ctyun.cn
    // },
    // s3ClientData: {
    //     Bucket: '',  //cqjtdx
    //     ACL: 'public-read',  // 初始化acl权限，默认为private，"private"|"public-read"|"public-read-write"
    // },
    // 阿里云签名
    OSS_REGION: "",  //oss-cn-beijing
    OSS_BUCKET: "",  //jjzxcqjtdx
    ACCESS_KEY_ID: "",  //LTAI5tKXXxUBhcP5wF3RMwfd
    ACCESS_KEY_SECRET: "",  //RNQ1rZip5zijDpn6kHG3e4WtxZUZ1B
    player:null
  },
  mutations: {
    // getStartYearListMutations(state, v) {
    //   setStore("startYearList", payload);
    //   state.startYearList = v;
    // },
    // loading
    loading(state, payload) {
      state.isFullLoading = payload;
      state.unread = payload
    },
    //保存时间戳
    getTimeMutation(state, payload) {
      setStore("time", payload);
      state.time = payload;
    },
    //当前专业
    gerStudentMajorMutation(state, payload) {
      setStore("studentMajor", payload);
      state.studentMajor = payload;
    },
    // 改变menu状态
    changeMenuMutation(state, payload) {
      state.menuActive = payload.name;
      setStore('menuActive', payload.name);
    },
    // 改变teacherRole状态
    changeTeacherMutation(state, payload) {
      state.teacherRole = payload;
      setStore('teacherRole', payload);
    },
    // 改变字体大小
    changeFont(state, payload) {
      state.fontClass = payload;
    },
    // 重置state
    clearStore(state) {
      state.studentMajor = null;
      state.menuActive = null;
      state.teacherRole = null;
    },
    // /**
    //  * 获取腾讯云签名数据
    //  * @param {*} state
    //  * @param {*} payload
    //  */
    // getCosMutations(state, payload) {
    //   if (payload) {
    //     const { credentials } = payload;
    //     state.cos = new Cos({
    //       getAuthorization: (options, callback) => {
    //         callback({
    //           TmpSecretId: credentials.tmpSecretId,
    //           TmpSecretKey: credentials.tmpSecretKey,
    //           SecurityToken: credentials.sessionToken,
    //           // 建议返回服务器时间作为签名的开始时间，避免用户浏览器本地时间偏差过大导致签名错误
    //           StartTime: payload.startTime, // 时间戳，单位秒，如：1580000000
    //           ExpiredTime: payload.expiredTime, // 时间戳，单位秒，如：1580000000
    //         });
    //       }
    //     });

    //     // state.cos = new Cos({
    //     //     AppId: credentials.appId,
    //     //     SecretId: credentials.secretId,
    //     //     SecretKey: credentials.secretKey,
    //     // });
    //   }
    // },
    // /**
    //      * 获取天翼云签名数据
    //      * @param {*} state
    //      * @param {*} payload
    //      */
    //  getS3ClientMutations(state, payload) {
    //   state.s3Client = new AWS.S3({
    //       accessKeyId: payload.accessKeyId,
    //       secretAccessKey: payload.secretAccessKey,
    //       endpoint: payload.endpoint,
    //       // s3ForcePathStyle: true,
    //       // httpOptions: {headers: "Content-Type:image/jpeg"}
    //   });
    //   state.s3ClientData.Bucket = payload.bucket;
    // },
    /**
     * 获取阿里云签名数据
     * @param {*} state
     * @param {*} payload
     */
    getS3ClientMutations(state, payload) {
      state.OSS_REGION = payload.region;
      state.OSS_BUCKET = payload.bucket;
      state.ACCESS_KEY_ID = payload.accessKeyId;
      state.ACCESS_KEY_SECRET = payload.accessKeySecret;
    },

    SET_PLAYER(state, player) {
      state.player = player;
    },
    REMOVE_PLAYER(state, userInfo) {
      state.player = null;
    },
  },
  actions: {
    /**
     * 获取学年
     */
    getStartYearList({commit}){
        return new Promise((resolve, reject) => {
          useryear().then(res => {
                if(res.code == 200){
                    resolve(res.result);
                    // commit('getStartYearListMutations', res.result);
                }
            });
        });
    },
    /**
         * 初始化阿里云签名
         * @param {*} param0
         */
     getS3ClientAction({ commit, dispatch }) {
      return new Promise((resolve, reject) => {
        cosInfos().then(res => {
            if (res.code == 200) {
                dispatch('decrypt', res.result).then(ress => {
                    // console.log(JSON.parse(ress));
                    commit('getS3ClientMutations', JSON.parse(ress));
                    resolve();
                });
            }
        });
      });
    },
    /**
     * 获取腾讯云签名
     * @param {*} param0
     */
    // getCosAction({ commit }) {
    //   return cosInfos().then(res => {
    //     if (res.code == 200) {
    //       commit('getCosMutations', res.result);
    //     }
    //   });
    // },
    // /**
    //      * 初始化天翼云签名
    //      * @param {*} param0
    //      */
    //  getS3ClientAction({ commit, dispatch }) {
    //   return new Promise((resolve, reject) => {
    //     cosInfos().then(res => {
    //         if (res.code == 200) {
    //             dispatch('decrypt', res.result).then(ress => {
    //                 // console.log(JSON.parse(ress));
    //                 commit('getS3ClientMutations', JSON.parse(ress));
    //                 resolve();
    //             });
    //         }
    //     });
    //   });
    // },
    /**解密
         * @param data
         * @returns {string}
         */
     decrypt({state}, data) {
      let encrypted = CryptoJS.enc.Utf8.stringify(CryptoJS.enc.Base64.parse(data)).toString();
      let key = CryptoJS.enc.Utf8.parse(state.s3ClientKV); //为了避免补位，直接用16位的秘钥
      let iv = CryptoJS.enc.Utf8.parse(state.s3ClientKV); //16位初始向量
      let decrypted = CryptoJS.AES.decrypt(encrypted, key, {
          iv: iv,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.ZeroPadding
      }).toString(CryptoJS.enc.Utf8);
      return CryptoJS.enc.Utf8.stringify(CryptoJS.enc.Base64.parse(decrypted)).toString();
    },
  },
  getters: {
  },
};
